// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Documents_headerWrapper__VfOL2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 24px;
}
@media (max-width: 1024px) {
  .Documents_headerWrapper__VfOL2 {
    flex-direction: column;
    padding-bottom: 8px;
  }
}

.Documents_title__N\\+YPx {
  font-size: 24px;
}
@media (max-width: 1024px) {
  .Documents_title__N\\+YPx {
    padding-bottom: 8px;
  }
}

.Documents_documentesWrapper__sPwYh {
  margin-top: 24px;
  background-color: #FFFFFF;
  border-radius: 32px;
  border: 1px solid #CFD6DD;
}

.Documents_modalWrapper__Jcfst {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Documents_table__nSmht {
  width: 100%;
  border: 1px solid #EAEDF0;
  background-color: #FFFFFF;
  border-collapse: collapse;
}

.Documents_tableHeader__oX2Tt {
  text-align: left;
  background-color: #F5F7F9;
  font-size: 12px;
}

.Documents_columnHeader__hiYFq {
  padding: 16px 24px;
}

.Documents_singleRow__SB8Dc {
  border-bottom: 1px solid #EAEDF0;
}
.Documents_singleRow__SB8Dc > td {
  padding: 16px 24px;
}

.Documents_badge__qDHBS {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 7px 8px;
  font-size: 14px;
  background-color: #C6F1DA;
  border-radius: 999px;
  color: #086E49;
  width: max-content;
}

.Documents_badgeDot__4ZYtl {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #0EB77A;
  margin-right: 9px;
}

.Documents_badgeSecondary__s64CA {
  color: #272E35;
  background-color: #DEE3E7;
}

.Documents_badgeDotSecondary__m4cp8 {
  background-color: #555F6D;
}`, "",{"version":3,"sources":["webpack://./src/containers/Tabs/Documents/Documents.module.scss","webpack://./src/styles/responsive.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AAFJ;ACHQ;EDCR;IAOQ,sBAAA;IACA,mBAAA;EADN;AACF;;AAIA;EACI,eAAA;AADJ;ACbQ;EDaR;IAIQ,mBAAA;EAAN;AACF;;AAGA;EACI,gBAAA;EACA,yBEzBI;EF0BJ,mBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,yBAAA;EACA,yBEvCI;EFwCJ,yBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,yBEzBM;EF0BN,eAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,gCAAA;AAAJ;AACI;EACA,kBAAA;AACJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBE5CO;EF6CP,oBAAA;EACA,cEnDc;EFoDd,kBAAA;AAAJ;;AAGA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBElEK;EFmEL,iBAAA;AAAJ;;AAGA;EAEI,cEhFM;EFiFN,yBE/EI;AF+ER;;AAIA;EAEI,yBEpFQ;AFmFZ","sourcesContent":["@use '../../../styles/colors' as colors; \n@use '../../../styles/responsive' as rwd; \n\n.headerWrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding-bottom: 24px;\n    \n    @include rwd.breakpoint(small) {\n        flex-direction: column;\n        padding-bottom: 8px;\n    }\n}\n\n.title {\n    font-size: 24px;\n    \n    @include rwd.breakpoint(small) {\n        padding-bottom: 8px;\n    }\n}\n\n.documentesWrapper {\n    margin-top: 24px;\n    background-color: colors.$white;\n    border-radius: 32px;\n    border: 1px solid colors.$action;\n}\n\n.modalWrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.table {\n    width: 100%;\n    border: 1px solid colors.$defaultAPP;\n    background-color: colors.$white;\n    border-collapse: collapse;\n}\n\n.tableHeader {\n    text-align: left;\n    background-color: colors.$neutral;\n    font-size: 12px;\n}\n\n.columnHeader {\n    padding: 16px 24px;\n}\n\n.singleRow {\n    border-bottom: 1px solid colors.$defaultAPP;\n    > td {\n    padding: 16px 24px;\n    }\n}\n\n.badge {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 7px 8px;\n    font-size: 14px;\n    background-color: colors.$greenAPP;\n    border-radius: 999px;\n    color: colors.$primaryGreenAPP;\n    width: max-content;\n}\n\n.badgeDot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: colors.$green0;\n    margin-right: 9px;\n}\n\n.badgeSecondary {\n    composes: badge;\n    color: colors.$primary;\n    background-color: colors.$grey4;\n}\n\n\n.badgeDotSecondary {\n    composes: badgeDot;\n    background-color: colors.$secondary;\n}","@mixin breakpoint($point) {\n    @if $point == small {\n        @media (max-width:  1024px) { @content; }\n    }\n    // @else if $point == medium {\n    //     @media (min-width:  769px) and (max-width: 1280px) { @content; }\n    // }\n    @else if $point == large {\n        @media (min-width:  1025px) { @content; }\n    }\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerWrapper": `Documents_headerWrapper__VfOL2`,
	"title": `Documents_title__N+YPx`,
	"documentesWrapper": `Documents_documentesWrapper__sPwYh`,
	"modalWrapper": `Documents_modalWrapper__Jcfst`,
	"table": `Documents_table__nSmht`,
	"tableHeader": `Documents_tableHeader__oX2Tt`,
	"columnHeader": `Documents_columnHeader__hiYFq`,
	"singleRow": `Documents_singleRow__SB8Dc`,
	"badge": `Documents_badge__qDHBS`,
	"badgeDot": `Documents_badgeDot__4ZYtl`,
	"badgeSecondary": `Documents_badgeSecondary__s64CA Documents_badge__qDHBS`,
	"badgeDotSecondary": `Documents_badgeDotSecondary__m4cp8 Documents_badgeDot__4ZYtl`
};
export default ___CSS_LOADER_EXPORT___;
